// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"7ef0eca8","398":"0f799bb6","624":"780d7ef0"}[chunkId] + ".chunk.css";
};